import React, { useState } from "react"
import { useNavigate } from "react-router-dom"
import { useAuth } from "../context/AuthContext"
import { doc, setDoc } from "firebase/firestore"
import { db } from "../firebase"
import logo from "../assets/logo.png"

export default function Navbar({ fixed }) {
  const [navbarOpen, setNavbarOpen] = useState(false)
  const navigate = useNavigate()
  const { currentUser, logout } = useAuth()
  const user = currentUser ? currentUser.uid : null

  const signout = async () => {
    const docRef = doc(db, "users", user)
    await setDoc(
      docRef,
      {
        isOnline: false,
      },
      {
        merge: true,
      }
    ).then(() => console.log("Document updated"))
    navigate("/")
    logout()
      .then(async (res) => {
        try {
          navigate("/")
        } catch (e) {
          console.error("Error adding document: ", e)
        }
        navigate("/")
      })
      .catch((error) => {
        alert(error.message)
      })
  }

  return (
    <>
      <nav className="relative flex flex-wrap items-center justify-between px-2 py-3 bg-indigo-500 ">
        <div className="container px-4 mx-auto flex flex-wrap items-center justify-between">
          <div className="w-full relative flex justify-between lg:w-auto lg:static lg:block lg:justify-start">
            <div
              className="cursor-pointer"
              onClick={() => {
                navigate("/")
              }}
            >
              <div className="flex items-center flex-no-shrink text-white">
                <img
                  src={logo}
                  alt="Consult Doctor Online"
                  className="w-10 h-10 rounded-full mr-2"
                />
                <span class="font-semibold text-xl tracking-tight">
                  Aries Online Clinic
                </span>

                {/* <span className="font-semibold text-xl tracking-tight">
                  Aries Clinic
                </span> */}
              </div>
            </div>

            <button
              className="text-white cursor-pointer text-xl leading-none px-3 py-1 border border-solid border-transparent rounded bg-transparent block lg:hidden outline-none focus:outline-none"
              type="button"
              onClick={() => setNavbarOpen(!navbarOpen)}
            >
              <span className="block relative w-6 h-px rounded-sm bg-white"></span>
              <span className="block relative w-6 h-px rounded-sm bg-white mt-1"></span>
              <span className="block relative w-6 h-px rounded-sm bg-white mt-1"></span>
            </button>
          </div>
          <div
            className={
              "lg:flex flex-grow items-center" +
              (navbarOpen ? " flex" : " hidden")
            }
            id="example-navbar-danger"
          >
            <ul className="flex flex-col lg:flex-row list-none lg:ml-auto">
              <li className="nav-item">
                <div
                  className="text-sm font-bold leading-relaxed inline-block mr-4 py-2 whitespace-nowrap uppercase text-white cursor-pointer"
                  onClick={() => {
                    navigate("/")
                  }}
                >
                  Home
                </div>
              </li>
              <li className="nav-item">
                <div
                  className="text-sm font-bold leading-relaxed inline-block mr-4 py-2 whitespace-nowrap uppercase text-white cursor-pointer"
                  onClick={() => {
                    navigate("/questions")
                  }}
                >
                  Your Questions
                </div>
              </li>
              <li className="nav-item">
                <div
                  className="text-sm font-bold leading-relaxed inline-block m-auto py-2 whitespace-nowrap uppercase text-white cursor-pointer"
                  onClick={() => {
                    signout()
                  }}
                >
                  Logout
                </div>
              </li>
            </ul>
          </div>
        </div>
      </nav>
    </>
  )
}
